export const setHeader = ({ headers = {} }) => ({
    headers: {
        ...headers,
        'x-product-code': window.config.PRODUCT_CODE,
    },
});

export default (operation, forward) => {
    if (window.config.PRODUCT_CODE) {
        operation.setContext(setHeader);
    }
    return forward(operation);
};
